import AuthState from "@/context/Auth/AuthState";
import { useAuth } from "@/context/Auth/CombinedAuthContext";
import InvoiceState from "@/context/Invoice/InvoiceState";
import UserState from "@/context/User/UserState";
import AlertState from "@/context/alert/AlertState";
import Login from "@/pages/Login";
import { useMsal } from "@azure/msal-react";
import { useEffect } from "react";
import ContributorRoute from "./ContributorRoute";
import RouteComponent from "./RouteComponent";

const MainContent = () => {
	const { accounts } = useMsal();
	const { person, loginWithAzure } = useAuth();

	const handleAuth = () => {
		if (person) return;
		if (!accounts || accounts.length === 0) {
			const currentPath = window.location.pathname;
			if (currentPath !== "/") {
				window.location.href = "/";
			}
			return;
		}
		loginWithAzure({
			persontype: "microsoft",
		});
	};

	// Whenever Azure logs in, sync with our context
	useEffect(() => {
		handleAuth();
	}, [accounts]);
	return (
		<div className="App">
			{person ? (
				person.persontype === "microsoft" ? (
					<UserState>
						<AuthState>
							<InvoiceState>
								<AlertState>
									<RouteComponent />
								</AlertState>
							</InvoiceState>
						</AuthState>
					</UserState>
				) : (
					<ContributorRoute />
				)
			) : (
				<Login />
			)}
		</div>
	);
};

export default MainContent;
